<template>
    <div class="tw-relative tw-bg-black tw-animate-pulse">
        <div class="sm:tw-py-12 md:tw-py-12 lg:tw-py-16 tw-py-16 tw-px-14">
            <div class="tw-flex tw-flex-col-reverse lg:tw-flex-row">
                <div class="tw-flex-grow lg:tw-pr-6">
                    <!-- Name  -->
                    <h1 class="tw-mb-2 tw-w-[350px] tw-h-10 tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full"></h1>
                    <!-- Focus -->
                    <div class="tw-mb-6 tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full tw-w-[150px] tw-h-6"></div>
                    <!-- Bio -->
                    <h2 class="tw-mb-0.5 tw-max-w-4xl tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full tw-w-full tw-h-5"></h2>
                    <h2 class="tw-mb-0.5 tw-max-w-4xl tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full tw-w-full tw-h-5"></h2>
                    <h2 class="tw-mb-10 tw-max-w-4xl tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full tw-w-full tw-h-5"></h2>
                </div>
                <div class="lg:tw-h-48 lg:tw-w-48">
                    <div
                        class="tw-mx-auto tw-mb-6 lg:tw-mb-0 lg:tw-mx-0 lg:tw-mr-4 tw-rounded-full tw-relative tw-w-48 tw-h-48 tw-overflow-hidden tw-flex-shrink-0 tw-bg-[#F2F2F2] dark:tw-bg-[#002039]">
                    </div>
                </div>
            </div>
            <div class="tw-bg-off-black tw-text-white">
                <!-- Brands -->
                <h1 class="tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full tw-h-8 tw-w-24"></h1>
                <div class="tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full mt-1 mb-3 tw-h-6 tw-w-28"></div>

                <!-- Endorsements -->
                <h1 class="tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full tw-h-8 tw-w-32"></h1>
                <div class="tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-full tw-w-36 tw-h-6 mt-1"></div>
            </div>
        </div>
    </div>
</template>
